import { Pipe, PipeTransform } from '@angular/core';
import { format, parseISO } from 'date-fns';

@Pipe({
    name: 'dateFormat',
    standalone: true
})
export class DateFormatPipe implements PipeTransform {

  transform(value: string | Date, formatString = 'EEEE MMMM dd, yyyy') {
    if (!value) return '';
    const dateObj = value instanceof Date ? value : parseISO(value as string);
    return format(dateObj, formatString);
  }

}
